import {useApi} from "@contexts/hooks/api/useApi.ts";
import {__contacontabil_endpoints} from "@components/contaContabil/endpoints/__contacontabil_endpoints.ts";
import {type IContasContabeisFiltroDto, ICreateContaContabilDto} from "@models/contaContabil/createContaContabilDto.ts";
import {IDataDto, IDataNoPageDto} from "@models/shared/IDataDto.ts";

export const useContaContabil = () => {
    const {Get} = useApi()
    const importContaContabil = (data: IDataNoPageDto<ICreateContaContabilDto[]>) => {
        return Get(__contacontabil_endpoints["import-conta-contabil"](data))
    }
    const getContasContabeis = (data: IDataDto<IContasContabeisFiltroDto>) => {
        return Get(__contacontabil_endpoints['v2']['get-contas-contabeis'](data))
    }

    return {importContasContabeis: importContaContabil, getContasContabeis}
};